export const NoData = () => {
  const template = `
      <div class="no-data">
        <img src="https://res.cloudinary.com/youfeatured-cloudname/image/upload/v1594462600/no_data.jpg" alt="no data"/>
        No data
      </div>
  `;

  return template;
};
